import { v4 as uuidv4 } from "uuid"
import { IdTableVariant } from "../../../../@types/enumsGlobal";
import useLockingDocuments from "../../../../components/lockDocuments/useLockingDocuments";
import { CreateVariant } from "../../../MasterTabsProvider";
import RequestForMovementGridPluginSettings from "../RequestForMovementGridPluginSettings";
import RequestForMovementItemsGridPluginSettings from "../RequestForMovementItems/RequestForMovementItemsGridPluginSettings";
import { RequestForMovementCreatorView } from "./RequestForMovementCreatorView";

export const RequestForMovementCreatorTab = (idGlobal: string, variant?: CreateVariant, parentCallback?: <T>(message: T) => void, mnemocode?: any): ITab => {
    const checkCopyTabVariantId = variant === "edit" && idGlobal !== undefined ? idGlobal : uuidv4();
    const titleTab = mnemocode ? `Заявка на перемещение ${mnemocode}` : "Заявка на перемещение";
    const lockingDocuments = useLockingDocuments();
    return {
        id: checkCopyTabVariantId,
        title: titleTab,
        plugin: "request_for_movement_create_plugin",
        mnemocode: mnemocode,
        closeWarning: true,
        onTabClosed: () => {
            lockingDocuments.delete({
                idTable: IdTableVariant.RequestForMovement,
                idDocument: idGlobal as string,
            });
        },
        view: {
            content: RequestForMovementItemsGridPluginSettings ? (
                <RequestForMovementCreatorView
                    variant={variant ?? "create"}
                    idGlobal={idGlobal}
                    createdCallback={parentCallback}
                    permission={RequestForMovementGridPluginSettings.permission as IPermission}
                />
            ) : (
                <p> Справочник не настроен </p>
            ),
        },
    };
};
